/**
 * Monster Quiz - Google Sheets Integration
 * Saves quiz results to a Google Sheet using Google Apps Script
 */

/**
 * Saves quiz results to Google Sheets
 * @param {Object} contactInfo - User contact information
 * @param {Array} answers - Array of answers
 * @param {String} dominantMonster - Primary monster type
 * @param {Array} secondaryMonsters - Secondary monster types
 * @returns {Promise} - Promise that resolves with the result
 */
async function saveQuizResultsToGoogleSheets(contactInfo, answers, dominantMonster, secondaryMonsters) {
  try {
    // First save to localStorage as backup
    saveToLocalStorage(contactInfo, answers, dominantMonster, secondaryMonsters);
    
    // Format secondary monsters as a string
    const secondaryMonstersString = secondaryMonsters.join(', ');
    
    // Create current timestamp
    const createdAt = new Date().toISOString();
    
    // Prepare the data to send
    const data = {
      name: contactInfo.name,
      phone: contactInfo.phone,
      primary_monster: dominantMonster,
      secondary_monsters: secondaryMonstersString,
      answers: JSON.stringify(answers),
      created_at: createdAt,
      url: window.location.href
    };
    
    // URL of the Google Apps Script Web App
    // You will replace this with your actual deployed Web App URL
    const scriptUrl = 'https://script.google.com/macros/s/AKfycbw5D2DGcAdz4_BnQ4KjOl2ENbTJZ8tBvLJEF3xSGUQVtAPiZeFFRe-3dO-yJVWlth6e/exec';
    
    // Create URL-encoded form data
    const formData = new URLSearchParams();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    
    // Send the data using fetch
    const response = await fetch(scriptUrl, {
      method: 'POST',
      mode: 'no-cors', // Important for cross-origin requests to Google Apps Script
      body: formData
    });
    
    // Since 'no-cors' mode doesn't allow reading the response,
    // we assume success if no error is thrown
    
    return {
      success: true,
      message: "Quiz result saved successfully to Google Sheets"
    };
  } catch (error) {
    console.error('Error saving quiz result to Google Sheets:', error);
    
    // Return failure but don't break the quiz
    return {
      success: false,
      error: error.message
    };
  }
}

/**
 * Updates the monster-quiz.js to use Google Sheets integration
 */
function updateQuizWithGoogleSheetsIntegration() {
  // In the calculateResults function in monster-quiz.js, 
  // replace the saveQuizResults call with:
  
  /*
  try {
    // Save to Google Sheets
    await saveQuizResultsToGoogleSheets(contactInfo, answers, dominantMonster, secondaryMonsters);
  } catch (saveError) {
    console.error('Error saving quiz results:', saveError);
    // Continue even if save fails
  }
  */
}